export const isProduction = () =>
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'production';

export const isDevelopment = () =>
  process.env.NEXT_PUBLIC_ENVIRONMENT === 'development';

// fetches content based on the environment set in Builder.io
export const getEnvironmentContent = (environment?: string) => {
  switch (environment) {
    case 'production':
      return [undefined, 'production'];
    case 'staging':
      return [undefined, 'production', 'staging'];
    case 'development':
      return [undefined, 'production', 'staging', 'development'];
    default:
      return [undefined, 'production', 'staging', 'development'];
  }
};
